"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const TaskRepository_1 = tslib_1.__importDefault(require("../repositories/TaskRepository"));
const tools_1 = require("../tools");
const createProject_graphql_1 = tslib_1.__importDefault(require("../gql/projects/mutations/createProject.graphql"));
const updateProject_graphql_1 = tslib_1.__importDefault(require("../gql/projects/mutations/updateProject.graphql"));
const deleteProject_graphql_1 = tslib_1.__importDefault(require("../gql/projects/mutations/deleteProject.graphql"));
const BaseModel_1 = tslib_1.__importDefault(require("./BaseModel"));
const repositories_1 = require("../repositories");
class Project extends BaseModel_1.default {
    constructor(props) {
        super(props);
        this.kanbans = repositories_1.KanbanRepository.fromArray((props === null || props === void 0 ? void 0 : props.kanbans) || []);
    }
    defaults() {
        var _a;
        return {
            uuid: '',
            name: '',
            tasks: [],
            kanbans: [],
            teams: [],
            users: [],
            client: null,
            currency: null,
            organization: {
                uuid: (_a = tools_1.getStore()) === null || _a === void 0 ? void 0 : _a.state.route.params.organizationUuid,
            },
        };
    }
    prepareVariables() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const project = yield this.getUpdateVariables();
            return {
                project,
            };
        });
    }
    create() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.generateUuid();
            return this.hydrate(yield this.mutate(createProject_graphql_1.default, yield this.prepareVariables()));
        });
    }
    update() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.hydrate(yield this.mutate(updateProject_graphql_1.default, yield this.prepareVariables()));
        });
    }
    delete() {
        const _super = Object.create(null, {
            delete: { get: () => super.delete }
        });
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return _super.delete.call(this, deleteProject_graphql_1.default);
        });
    }
    fetchTasks() {
        return (new TaskRepository_1.default()).many({});
    }
}
exports.default = Project;
//# sourceMappingURL=Project.js.map